import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getStaffYearlyAttendanceExportList: (state) => state.items,
  getStaffYearlyAttendanceExportListPagination: (state) => state.pagination,
  getStaffYearlyAttendanceExportListPage: (state) =>
    state.pagination.current_page,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
